import React from "react"
import PropTypes from "prop-types"
import Select from "react-select"

import { etiquetaFecha } from "../../Daily/useOrdersCreate"
import { etiquetaCierre, etiquetaLarga } from "../helpers"

const OrderHeaderV2 = ({
  clients,
  clientId,
  dates,
  date,
  addresses,
  addressId,
  address,
  minutosCierre,
  onChangeClient,
  onChangeDate,
  onChangeAddress,
}) => {
  const opcionesCliente = clients.map(cliente => ({
    label: cliente.company_name,
    value: cliente.id,
  }))
  const clienteSeleccionado =
    opcionesCliente.find(opcion => opcion.value === clientId) || null

  return (
    <div className="pv2-header-row">
      <div className="pv2-title">
        <div className="pv2-overline">Crear pedido</div>
        <div className="pv2-title-date">{etiquetaLarga(date)}</div>
        {minutosCierre !== null && (
          <div
            className={`pv2-cierre${minutosCierre <= 0 ? " is-closed" : ""}`}
          >
            {etiquetaCierre(minutosCierre)}
          </div>
        )}
      </div>

      <div className="pv2-field is-wide">
        <label className="pv2-label" htmlFor="pv2-cliente">
          Cliente
        </label>
        <Select
          inputId="pv2-cliente"
          classNamePrefix="pv2-select"
          options={opcionesCliente}
          value={clienteSeleccionado}
          onChange={opcion => onChangeClient(opcion ? opcion.value : null)}
          placeholder="- Seleccionar cliente -"
          noOptionsMessage={() => "Sin clientes"}
          isClearable
        />
      </div>

      <div className="pv2-field">
        <label className="pv2-label" htmlFor="pv2-fecha">
          Fecha pedido
        </label>
        <select
          id="pv2-fecha"
          className="pv2-input"
          value={date || ""}
          onChange={event => onChangeDate(event.target.value)}
          disabled={dates.length === 0}
        >
          {dates.length === 0 && (
            <option value={date}>{etiquetaFecha(date)}</option>
          )}
          {dates.map(dia => (
            <option key={dia} value={dia}>
              {etiquetaFecha(dia)}
            </option>
          ))}
        </select>
      </div>

      <div className="pv2-field is-wide">
        <label className="pv2-label" htmlFor="pv2-direccion">
          Dirección de entrega
        </label>
        <select
          id="pv2-direccion"
          className="pv2-input"
          value={addressId || ""}
          onChange={event => onChangeAddress(Number(event.target.value))}
          disabled={addresses.length === 0}
        >
          {addresses.length === 0 && (
            <option value="">- Seleccionar dirección -</option>
          )}
          {addresses.map(direccion => (
            <option key={direccion.id} value={direccion.id}>
              {direccion.address_string}
            </option>
          ))}
        </select>
      </div>

      <div className="pv2-field is-auto">
        <span className="pv2-label">Región de entrega</span>
        <span className="pv2-region">
          <span className="pv2-region-dot" />
          {address?.region?.name || "—"}
        </span>
      </div>
    </div>
  )
}

OrderHeaderV2.propTypes = {
  clients: PropTypes.array.isRequired,
  clientId: PropTypes.number,
  dates: PropTypes.array.isRequired,
  date: PropTypes.string,
  addresses: PropTypes.array.isRequired,
  addressId: PropTypes.number,
  address: PropTypes.object,
  minutosCierre: PropTypes.number,
  onChangeClient: PropTypes.func.isRequired,
  onChangeDate: PropTypes.func.isRequired,
  onChangeAddress: PropTypes.func.isRequired,
}

export default OrderHeaderV2
